const memoryCache = new Map();

const now = () => Date.now();

const todayLocalDate = () => {
  const date = new Date();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${date.getFullYear()}-${month}-${day}`;
};

const normalizeCacheKey = (key) => String(key || "").trim().toLowerCase();

const isFresh = (entry) => entry && entry.expiresAt > now();

const getCachedPayload = (key) => {
  const normalizedKey = normalizeCacheKey(key);
  const entry = memoryCache.get(normalizedKey);

  if (!isFresh(entry)) {
    memoryCache.delete(normalizedKey);
    return null;
  }

  return entry.payload;
};

const setCachedPayload = (key, payload, ttlMs) => {
  if (!key || payload === undefined || payload === null || ttlMs < 1) {
    return;
  }

  memoryCache.set(normalizeCacheKey(key), {
    payload,
    expiresAt: now() + ttlMs,
  });
};

const clearCachedPayload = (key) => {
  memoryCache.delete(normalizeCacheKey(key));
};

const debounce = (callback, delay = 350) => {
  let timer = null;

  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => callback(...args), delay);
  };
};

const hasBasicEmailShape = (value) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || "").trim());
};

const getCachedServerDate = async (getItems, { force = false, ttlMs = 5 * 60 * 1000 } = {}) => {
  const cacheKey = "operator-server-date";
  const cached = !force ? getCachedPayload(cacheKey) : null;
  const today = todayLocalDate();

  if (cached?.data?.current_date_full === today) {
    return { res: { value: cached }, err: { value: null }, cached: true };
  }

  const result = await getItems("operator/server/date");

  if (result.res.value?.data?.current_date_full === today) {
    setCachedPayload(cacheKey, result.res.value, ttlMs);
  }

  return { ...result, cached: false };
};

export {
  clearCachedPayload,
  debounce,
  getCachedPayload,
  getCachedServerDate,
  hasBasicEmailShape,
  setCachedPayload,
};
